import React from "react";

const AppContext = React.createContext({ isLoggedIn: null, user: null });

export default AppContext;
